import { TBodyType, TListBodyType, TTakeListType, TDownType } from "@/module/public";
import request from "@/utils/requset";
export const GetItemlist = () => { }

// 添加学习记录
export const addLearnTake = (data: TBodyType) => {
    return request<TBodyType>({
        url: '/api/user/learningrecords/editrecords',
        method: 'POST',
        data
    })
}
// 获取学习记录列表
export const getLearnTakeList = (data: TListBodyType) => {
    return request<TListBodyType, TTakeListType>({
        url: '/api/user/learningrecords/getrecordslist',
        method: 'POST',
        data
    })
}

// 获取下载参数
export const getAliossSetting = () => {
    return request<TDownType>({
        url: '/api/public/getaliosssetting',
        method: 'GET'
    })
}